import React, { Component } from 'react';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

import Alert from 'components/ui/Alert';
import CargomaticCard from 'components/v2/card';
import CargomaticInput from 'components/v2/input';
import CargomaticSelect from 'components/v2/select';
import CustomersActionCreators from 'actions/CustomersActionCreators';
import VALIDATION_STATES from 'constants/ValidationStates';
import SessionStore from 'stores/SessionStore';
import BillingStore from 'stores/shipper/BillingStore';
import ToastStore from 'stores/ToastStore';

const months = BillingStore.getExpireMonthAvaliableValues().map((m) => ({
  name: m,
  value: m,
}));

function getStripeCustomerId() {
  const user = SessionStore.getUser();
  if (user.stripe_customer_id) {
    return user.stripe_customer_id;
  }
  return 'No Stripe ID (No Card Registered)';
}

class CreditCardForm extends Component {
  static isCardExist() {
    return !!SessionStore.getUser().stripe_customer_id;
  }

  static getExpiryMonthFromInt(expMonth) {
    if (expMonth < 10) {
      return `0${expMonth}`;
    }
    return expMonth.toString();
  }

  constructor(props) {
    super(props);
    this.state = {
      cardNumber: '',
      expiryMonth: BillingStore.getExpireMonthAvaliableValues()[0],
      expiryYear: BillingStore.getStartExpireYear(),
      cvv: '',
      validations: {},
      loading: CreditCardForm.isCardExist(),
    };
  }

  componentDidMount() {
    BillingStore.addChangeListener(this.refresh);
    if (CreditCardForm.isCardExist()) {
      CustomersActionCreators.getCreditCards(SessionStore.getUser()._id);
    }
  }

  componentWillUnmount() {
    BillingStore.removeChangeListener(this.refresh);
  }

  onSave = () => {
    ToastStore.removeLatestNotification();
    const { cardNumber, cvv, expiryMonth, expiryYear } = this.state;
    const data = {
      cvv,
      cardNumber,
      expiryMonth,
      expiryYear,
      userId: SessionStore.getUser()._id,
    };
    CustomersActionCreators.validateAndUpdateCreditCard(data);
  };

  handleInputChange = (field) => (value) => {
    this.setState({
      [field]: value,
    });
  };

  handleMonthChange = (item) => {
    this.setState({ expiryMonth: item.value });
  };

  refresh = () => {
    this.updateValidation();
    this.updateCreditCard();
  };

  updateCreditCard() {
    if (this.state.loading) {
      const creditCard = BillingStore.getCreditCard();
      this.setState({
        cardNumber: `************${creditCard.last4}`,
        expiryMonth: CreditCardForm.getExpiryMonthFromInt(creditCard.exp_month),
        expiryYear: creditCard.exp_year,
        loading: false,
      });
    }
  }

  updateValidation() {
    this.setState({
      validations: BillingStore.getCreditCardValidation(),
    });
  }

  render() {
    const { t } = this.props;
    const formDetails = (
      <CargomaticCard
        className={this.props.className}
        header={() => (
          <div className="flex items-center space-x-2 justify-between">
            <h3 className="my-0">{t('CREDIT_CARD')}</h3>
            <span>
              {t('STRIPE_CUSTOMER_ID')}: {getStripeCustomerId()}
            </span>
          </div>
        )}
        footer={() => (
          <div className="actions">
            <button className="button button-green" onClick={this.onSave}>
              {titleize(t('SAVE'))}
            </button>
          </div>
        )}
        grayFooter
      >
        <div className="mb-4 sm:grid sm:grid-cols-6 sm:gap-4">
          <div className="sm:col-span-4">
            <CargomaticInput
              label={t('CARD_NUMBER')}
              value={this.state.cardNumber}
              onChange={this.handleInputChange('cardNumber')}
            />
          </div>
        </div>
        <div className="sm:grid sm:grid-cols-6 sm:gap-4">
          <CargomaticSelect
            name="expiryMonth"
            label={t('EXPIRY_MONTH')}
            value={this.state.expiryMonth}
            onSelect={this.handleMonthChange}
            items={months}
            valueKey="value"
            textKey="name"
          />
          <CargomaticInput
            name="expiryYear"
            type="number"
            step={1}
            min={1900}
            label={t('EXPIRY_YEAR')}
            value={this.state.expiryYear}
            onChange={this.handleInputChange('expiryYear')}
          />
          <CargomaticInput
            name="cvv"
            type="number"
            step={1}
            label={t('CVV')}
            value={this.state.cvv}
            onChange={this.handleInputChange('cvv')}
          />
        </div>
      </CargomaticCard>
    );

    return (
      <div className={this.props.className}>
        {!_.isEmpty(this.state.validations) && (
          <Alert type="error">
            <ul>
              {_.values(this.state.validations).map((error) => (
                <li key={error}>{t(error)}</li>
              ))}
            </ul>
          </Alert>
        )}
        {this.state.loading ? <div>{t('LOADING')}</div> : formDetails}
      </div>
    );
  }
}
export default withTranslation()(CreditCardForm);
